<template>
  <div class="detail">
    <div class="head">INVOICE</div>
    <div class="content">
      <div class="tag" v-if="type != 'KS-JP航空便' || type != 'KS-JP航空経済便'">
        <!-- 发票编辑界面 -->
        <span :class="{ index: index == 1 }" @click="index = 1">{{
          $t("message.invoiceEditingInterface")
        }}</span>
        <!-- 装箱数据明细 -->
        <span :class="{ index: index == 2 }" @click="index = 2">{{
          $t("message.packingDetails")
        }}</span>
      </div>

      <!-- 发货方式 -->
      <div v-show="index == 1">
        <!-- EMS -->
        <EMS :detail="detail" v-if="type == 'EMS' || type == 'EMS船便'" />
        <!-- OCS -->
        <OCS :detail="detail" v-if="type == 'OCS'" />
        <!-- DQ  -->
        <DQ :detail="detail"
          v-if="type == '海源DQ船便' || type == '海源TK船便' || type == 'Raku-DQ' || type == 'FBA新幹線' || type == '海源電子特殊航空便' || type == 'Rロジ専用船便'" />
        <!-- TW -->
        <TW :detail="detail" v-if="type == 'TW船便' || type == 'RW船便'" />
        <!-- KS_JP -->
        <KS_JP :detail="detail" v-if="type == 'KS-JP航空便' || type == 'KS-JP航空経済便' || type == 'KS-JP電子特殊便'" />
      </div>
      <!-- 装箱明细 -->
      <packingDetails v-show="index == 2" :base="detail.base" />
    </div>
    <!-- 注意事项 -->
    <getNotice ref="getNotice" />
  </div>
</template>
<script>
import { mapState } from "vuex";
import packingDetails from "./components/packingDetails";
import EMS from "./components/EMS";
import OCS from "./components/OCS";
import DQ from "./components/DQ";
import TW from "./components/TW";
import KS_JP from "./components/KS-JP";
export default {
  components: { packingDetails, EMS, OCS, DQ, TW, KS_JP },
  data() {
    return {
      index: 1,
      detail: { base: {}, delivery: {}, importer: {}, list: [], receiver: {} },
      type: this.$route.query.type,
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
    }),

  },
  created() {
    if (this.type == 'KS-JP航空便' || this.type == 'KS-JP航空経済便' || this.type == 'KS-JP電子特殊便') {

    } else {
      this.editPreview();
    }

  },
  methods: {
    editPreview() {
      let datas = {
        express_no: this.$route.query.express_no,
      };
      this.$api.invoiceApi.editPreview(datas).then((res) => {
        res.data.base.logistics_freight = res.data.base.logistics_freight ? res.data.base.logistics_freight : 0
        res.data.list.forEach(item => {
          item.checked = false

        })
        if (res.data.importer == null) {
          res.data.importer = {}
        }
        this.$nextTick(() => {

          this.detail = res.data;
          this.$refs.getNotice.getNotice(this.detail.base.porder_sn.split('-')[1], "业务注意事项", '发票')
          console.log(this.detail);
        })
      });
    },

  },
};
</script>
<style lang='scss' scoped>
.detail {
  min-width: 1910px;
}

.head {
  padding: 31px 80px;
  background-color: #32323c;
  color: #fff;
  font-size: 24px;
  font-weight: bold;
}

.content {
  padding: 40px 80px;

  .tag {
    margin-bottom: 43px;
    display: flex;

    span {
      display: flex;
      width: 156px;
      height: 46px;
      border: 2px solid #b4272d;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      color: #b4272d;
      cursor: pointer;

      &:nth-child(1) {
        border-right: 0;
        border-radius: 4px 0px 0px 4px;
      }

      &:nth-child(2) {
        border-radius: 0px 4px 4px 0px;
      }
    }

    .index {
      background-color: #b4272d;
      color: #fff;
    }
  }

  h6 {
    margin-bottom: 20px;
    font-size: 18px;
    color: #333;
  }
}
</style>
